import { type FC, useEffect, useState } from 'react';

import type { DropdownOption as DropdownOptionType } from 'components/Dropdown/Dropdown.types.ts';
import Typography from 'components/Typography';

import {
  HelperText,
  RadioButtonContainer,
  RadioButtonContent,
  RadioButtonIndicator,
  RadioButtonIndicatorInner,
  RadioButtonStyled,
} from './RadioButton.styled.ts';
import type { RadioButtonProps } from './RadioButton.types.ts';

const RadioButton: FC<RadioButtonProps> = ({
  options,
  value,
  title,
  helperText,
  onChange,
}) => {
  const [indexSelected, setIndexSelected] = useState(-1);

  useEffect(() => {
    const index = options.findIndex(option => option.value === value);

    setIndexSelected(index);
  }, [value, options]);

  const handleSelect = (option: DropdownOptionType, index: number) => {
    onChange(option.value);
    setIndexSelected(index);
  };

  return (
    <RadioButtonContainer>
      {title && (
        <Typography type="Body" size="small" color="#595959">
          {title}
        </Typography>
      )}

      <RadioButtonContent>
        {options.map((option, index) => (
          <RadioButtonStyled
            key={`radio-button-${index}`}
            items={options.length}
            onClick={() => handleSelect(option, index)}
          >
            <Typography
              type="Body"
              size="small"
              style="semibold"
              color="#5F522D"
            >
              {option.label}
            </Typography>

            <RadioButtonIndicator checked={index === indexSelected}>
              {index === indexSelected && <RadioButtonIndicatorInner />}
            </RadioButtonIndicator>
          </RadioButtonStyled>
        ))}
      </RadioButtonContent>

      {helperText && (
        <HelperText>
          <Typography type="Label" size="medium" color="#595959">
            {helperText}
          </Typography>
        </HelperText>
      )}
    </RadioButtonContainer>
  );
};

export default RadioButton;
